import React, { SVGProps } from 'react'

export const CigarSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#2E2A29"
      fillRule="evenodd"
      d="M4.094 1.71a1 1 0 0 1 1.403.176c.606.78 1.446 1.95 1.692 3.591.249 1.664-.133 3.652-1.633 6.053-1.15 1.84-1.364 3.278-1.23 4.346.134 1.081.641 1.902 1.134 2.466a1 1 0 0 1-1.505 1.317c-.673-.77-1.416-1.95-1.614-3.535-.2-1.599.169-3.494 1.519-5.654 1.312-2.1 1.513-3.611 1.35-4.697-.165-1.109-.731-1.938-1.292-2.659a1 1 0 0 1 .176-1.403Zm4.565 1.393a1 1 0 0 1 1.34.454c.916 1.856 1.238 4.983-.943 8.473l-.263.42c-.68 1.081-.949 1.508-1.04 2.183a1 1 0 1 1-1.981-.266c.151-1.133.674-1.956 1.313-2.962.09-.141.182-.285.275-.435 1.82-2.91 1.45-5.302.845-6.527a1 1 0 0 1 .454-1.34Z"
      clipRule="evenodd"
    />
    <path
      fill="#2E2A29"
      d="M8.208 17.5h11a2.5 2.5 0 1 1 0 5h-11a2.5 2.5 0 0 1 0-5Z"
    />
  </svg>
)
